import { render, staticRenderFns } from "./CommonUploadList.vue?vue&type=template&id=5a9a9f4f&scoped=true&"
import script from "./CommonUploadList.vue?vue&type=script&lang=js&"
export * from "./CommonUploadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a9f4f",
  null
  
)

export default component.exports